import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <>
            <footer className='footer section'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="footer-logo">
                                <Link to="/">
                                    <img src="assets/images/logo/logo.png" alt="OMICRON GRINDING MACHINES PVT. LTD." />
                                </Link>
                            </div>
                            <p className='text-light mb-0'>“OMICRON” stands for over 40 years of excellence in the design, development, and manufacturing of precision cylindrical and centerless grinding machines. Our passion for “Perfection through innovation” drives us to achieve unmatched precision and deliver superior quality in everything we do.</p>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-7">
                                    <h5>Products</h5>
                                    <ul>
                                        <li>
                                            <Link to="">Centerless Grinding Machine</Link>
                                        </li>
                                        <li>
                                            <Link to="">Cylindrical Grinding Machine</Link>
                                        </li>
                                        <li>
                                            <Link to="">Internal Grinding Machines</Link>
                                        </li>
                                        <li>
                                            <Link to="">Angular Grinding Machines</Link>
                                        </li>
                                        <li>
                                            <Link to="">SPM Grinding Machines</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-5">
                                    <h5>Other Links</h5>
                                    <ul>
                                        <li>
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li>
                                            <Link to="/aboutus">About Us</Link>
                                        </li>
                                        <li>
                                            <Link to="/infrastructure">Infrastructure - R&D</Link>
                                        </li>
                                        <li>
                                            <Link to="/mission-achievements">Mission & Achievements</Link>
                                        </li>
                                        <li>
                                            <Link to="/contactus">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-3">
                            <h5>Contact Details</h5>
                            <div className="footer-detail">
                                <p className='text-light'>Plot No 2212, GIDC Phase IV,<br />Wadhwan City, Surendranagar - 363035</p>
                                <p className='text-light'>
                                    <i className='fa fa-phone-volume me-3'></i>
                                    <Link to="tel:+919879697447">+91 98796 97447</Link>
                                </p>
                                <p className='text-light'>
                                    <i className='fa fa-envelope me-3'></i>
                                    <Link to="">omicroncorporate@gmail.com</Link>
                                </p>
                                <p className='text-light'>
                                    <i className='fa fa-globe-asia me-3'></i>
                                    <Link to="">www.omicrongrind.net</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="copyrights">
                <div className="container-fluid">
                    <p className='text-center text-light'>© 2025. Omicron Machine Tools Pvt. Ltd. All Rights Reserved.</p>
                </div>
            </div> 
        </>
    )
}
